// import * as actions from '../../actions/actionTypes';

const initialState = [];

export default function freeONLGChannelSettingList(state = initialState, action) {
  switch (action.type) {
    case 'SET_FREEONLG_SETTINGLIST':
      if (action.payload.status) {
        return state;
      } else if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    default:
      return state;
  }
}
